import { render, staticRenderFns } from "./ChangeLogs.html?vue&type=template&id=7796e4e5&scoped=true&"
import script from "./ChangeLogs.js?vue&type=script&lang=js&"
export * from "./ChangeLogs.js?vue&type=script&lang=js&"
import style0 from "./ChangeLogs.scss?vue&type=style&index=0&id=7796e4e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796e4e5",
  null
  
)

export default component.exports